import { StripeElementsOptions } from "@stripe/stripe-js";

export interface IPlan {
  title: string;
  price: string | number;
  features: Array<string>;
  salePrice?: number;
  preFix?: string;
  postFix?: string;
  btn?: string;
  note?: string;
  planKey?: string;
}

export const plans: Array<IPlan> = [
  {
    title: "Talent Pool",
    preFix: "$",
    price: 20,
    postFix: "  per recruiter/month",
    planKey: "talent_pool",
    features: [
      "Keep your entire candidate pool active and searchable",
      "Get notified when candidates update their availability or job status",
      "Search and filter candidates by skills, location, and experience",
      "Re-engage past candidates when a new role opens up",
      "Full candidate profile access",
    ],
    btn: "Purchase",
  },
  {
    title: "Premium",
    preFix: "$",
    salePrice: 99,
    price: 99,
    postFix: "  per recruiter/month",
    planKey: "standerd",
    note: "7-day free trial — no credit card required",
    features: [
      "AI screening and auto-ranking for every application",
      "Auto-updated candidate pool with passive candidate alerts",
      "One-click candidate submission to hiring managers",
      "AI-generated feedback for rejected candidates",
      "Interview scheduling and coordination",
      "Single sign-on with Microsoft",
    ],
    btn: "Purchase",
  },
  {
    title: "Enterprise",
    price: "Contact Us",
    features: [
      "Everything in Premium",
      "Custom features tailored to your hiring process",
      "Custom sign-in and authentication options",
      "Dedicated onboarding and priority support",
      "Suitable for agencies and high-volume hiring teams",
    ],
    btn: "Contact Us",
  },
];

export const stripeCurrency = 'usd';